const redis = require("redis");
const { promisify } = require("util");

const port = process.env.REDIS_OVERRIDE_PORT || process.env["redis/port"];
const hostname = process.env.REDIS_OVERRIDE_HOSTNAME || process.env["redis/hostname"];
const password = process.env.REDIS_OVERRIDE_PASSWORD || process.env["redis/password"] || "";

const client = redis.createClient(port, hostname, { no_ready_check: true });

client.auth(password, function (err) {
  if (err) throw err;
});

client.on("connect", function () {
  console.log("Connected to Redis on port " + port);
});

client.on("error", function (err) {
  console.log("Error " + err);
});

const promisifyMethod = (client, methodName) => {
  const promisifed = promisify(client[methodName]).bind(client);
  // put it on instance for sequlize cache
  client[`${methodName}Async`] = promisifed;
  return promisifed;
};

process.on("SIGINT", function () {
  client.quit();
});

module.exports = {
  getAsync: promisifyMethod(client, "get"),
  mgetAsync: promisifyMethod(client, "mget"),
  setAsync: promisifyMethod(client, "set"),
  setexAsync: promisifyMethod(client, "setex"),
  lpushAsync: promisifyMethod(client, "lpush"),
  lrangeAsync: promisifyMethod(client, "lrange"),
  ltrimAsync: promisifyMethod(client, "ltrim"),
  lremAsync: promisifyMethod(client, "lrem"),
  saddAsync: promisifyMethod(client, "sadd"),
  smembersAsync: promisifyMethod(client, "smembers"),
  sismemberAsync: promisifyMethod(client, "sismember"),
  hsetAsync: promisifyMethod(client, "hset"),
  hgetAsync: promisifyMethod(client, "hget"),
  hgetallAsync: promisifyMethod(client, "hgetall"),
  delAsync: promisifyMethod(client, "del"),
  sremAsync: promisifyMethod(client, "srem"),
  scanAsync: promisifyMethod(client, "scan"),
  existsAsync: promisifyMethod(client, "exists"),
  redisClient: client
};
